import { useDeleteStore } from '../../hooks';
import { TaskDeleteModalView } from '../../components/TaskDeleteModalView';

export const TaskDeleteModal = () => {
  const deleteStore = useDeleteStore();

  return <TaskDeleteModalView {...deleteStore} />;
};
